export default {
    name: '',
    email: '',
    phoneNumber: '',
    password: '',
    company: '',
    identityToken: '',
}
